export default "__VITE_ASSET__5U7uqC2c__"